import React from "react";
import { Box, createStyles } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import moment from "moment";
import "moment-timezone";
import MarDetailModal from "../MarDetailModal";
import { getColor } from "../../pages/Home/Medication";
import MedicationModal from "../MedicationModal";
import { useRef, useState } from "react";
import PRNMedicationModal from "../PRNMedicationModal";
import { useSelector } from "react-redux";

const useStyles = createStyles((theme) => ({
  monthCardBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    padding: "8px 6px",
    height: "190px",
    border: "1px solid var(--app-border)",
    borderLeft: "none",
    "& p": {
      margin: 0,
    },
    [theme.fn.smallerThan("sm")]: {
      height: "130px",
      padding: "4px 3px",
      gap: "3px",
    },
  },
  todayCard: {
    backgroundColor: "var(--app-tint-blue)",
  },
  todayDte: {
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "20px",
    maxHeight: "20px",
    minWidth: "20px",
    maxWidth: "20px",
  },
  todayDteActive: {
    backgroundColor: "#404040",
    "& p": {
      color: "#fff",
    },
  },
  dateRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "& > div": {
      flex: 1,
      display: "flex",
    },
    "& p": {
      color: "var(--app-text)",
      fontSize: "12px",
      fontWeight: 400,
      textTransform: "uppercase",
      fontFamily: "Inter",
    },
    [theme.fn.smallerThan("sm")]: {
      "& p": { fontSize: "10px" },
    },
  },
  generalRow: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    "& .colorBox": {
      width: "13px",
      height: "13px",
    },
    "& .medName": {
      flex: 1,
      fontSize: "14px",
      color: "var(--app-text-muted)",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "normal",

      display: "inline-block",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .medDose": {
      fontSize: "10px",
      color: "var(--app-text-muted)",
      fontStyle: "normal",
      fontWeight: 300,
      lineHeight: "normal",
      width: "43px",

      display: "inline-block",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .medTime": {
      fontSize: "9px",
      color: "var(--app-text-muted)",
      fontStyle: "normal",
      fontWeight: 300,
      lineHeight: "normal",
      width: "40px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .iconBox": {
      fontSize: "12px",
      width: "18px",
      "& img": {
        marginBottom: "-2px",
      },
    },
  },
  missedRow: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    borderRadius: "5px",
    padding: "0px 0px 0px 0px",
    "& .medName": {
      flex: 1,
      fontSize: "14px",
      color: "#F00",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "normal",

      display: "inline-block",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .medDose": {
      fontSize: "10px",
      color: "#F00",
      fontStyle: "normal",
      fontWeight: 300,
      lineHeight: "normal",
      width: "43px",

      display: "inline-block",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .medTime": {
      fontSize: "9px",
      color: "#F00",
      fontStyle: "normal",
      fontWeight: 300,
      lineHeight: "normal",
      width: "40px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .iconBox": {
      fontSize: "12px",
      width: "18px",
      "& img": {
        marginBottom: "-3px",
      },
    },
  },
  prnRow: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    borderRadius: "5px",
    background: "rgba(136, 0, 128, 0.15)",
    padding: "0px 0px 0px 0px",
    "& .medName": {
      flex: 1,
      fontSize: "14px",
      color: "#880080",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "normal",

      display: "inline-block",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .medDose": {
      fontSize: "10px",
      color: "#880080",
      fontStyle: "normal",
      fontWeight: 300,
      lineHeight: "normal",
      width: "43px",

      display: "inline-block",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .medTime": {
      fontSize: "9px",
      color: "#880080",
      fontStyle: "normal",
      fontWeight: 300,
      lineHeight: "normal",
      width: "40px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .iconBox": {
      fontSize: "12px",
      width: "18px",
      "& img": {
        marginBottom: "-3px",
      },
    },
  },
  moreRow: {
    display: "flex",
    justifyContent: "center",
    "& p": {
      color: "var(--app-text-muted)",
      fontSize: "13px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "normal",
      cursor: "pointer",
    },
  },
  monthCard: {
    padding: "2px 8px",
    borderRadius: 2,
    borderWidth: 1,
    borderStyle: "solid",
    cursor: "pointer",
    display: "flex",
    gap: "5px",
    alignItems: "center",
    "& .medTime": {
      fontSize: "10px",
      fontWeight: 500,
      fontFamily: "Inter",
      lineHeight: "normal",
    },
    "& .medName": {
      fontSize: "12px",
      fontWeight: 500,
      fontFamily: "Inter",
      lineHeight: "normal",
      flex: 1,
      display: "inline-block",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    [theme.fn.smallerThan("sm")]: {
      padding: "1px 4px",
      gap: "3px",
      "& .medTime": { display: "none" },
      "& .medName": { fontSize: "9px" },
    },
  },
}));

const MonthCard = ({ data, date, calendar }) => {
  // console.log("data", data);
  // console.log("date", date);
  // console.log("calendar", calendar);
  const { classes } = useStyles();
  const { selectedClient } = useSelector((state) => state.mar);
  const { profile } = useSelector((state) => state.profile);

  // ─── Helper: derive the most relevant status for a MAR record on a given date ──
  // Checks the medicationType array for an entry matching the date AND timeSlot.
  // Falls back to a date-only match, then to the last entry, then to the string value.
  // This ensures Refused / Out of Medication / Unable to Take are detected correctly
  // even when the stored timeSlot inside the array entry differs slightly.
  const getMedicationStatusForDate = (med, date) => {
    const medType = med?.medicationType;
    if (!medType) return "upcoming";

    if (Array.isArray(medType)) {
      const targetDateStr = moment(date).format("YYYY-MM-DD");
      const entrySlot = med.timeSlot;

      // Find the most relevant stored status for this date+slot.
      // For definitively-administered outcomes (Taken, Refused, etc.) we trust
      // the stored value and return immediately.
      // For "upcoming"/"Missed" we NEVER return the stored value — it may be
      // stale (stamped at page-load time or set by virtual-entry generation).
      // Instead we always fall through to the live date/time recompute below.
      const findStatus = () => {
        const exactMatches = medType.filter(
          (m) =>
            moment(m.date).format("YYYY-MM-DD") === targetDateStr &&
            m.timeSlot === entrySlot,
        );
        if (exactMatches.length > 0)
          return exactMatches[exactMatches.length - 1].status;

        const dateOnlyMatches = medType.filter(
          (m) =>
            moment(m.date).format("YYYY-MM-DD") === targetDateStr &&
            !m.timeSlot,
        );
        if (dateOnlyMatches.length > 0)
          return dateOnlyMatches[dateOnlyMatches.length - 1].status;

        return null;
      };

      const storedStatus = findStatus();
      if (
        storedStatus !== null &&
        storedStatus !== "upcoming" &&
        storedStatus !== "Missed"
      ) {
        return storedStatus;
      }

      // Derive status from the actual date and slot time (always fresh)
      const nowInBiz = moment();
      const startOfToday = nowInBiz.clone().startOf("day");
      if (moment(date).isBefore(startOfToday, "day")) return "Missed";
      if (moment(date).isAfter(startOfToday, "day")) return "upcoming";
      // Today: check whether the slot time has already passed
      const slotMoment = entrySlot
        ? moment(entrySlot, ["hh:mm A", "HH:mm"])
        : null;
      if (slotMoment && slotMoment.isValid()) {
        const slotToday = startOfToday.clone().set({
          hour: slotMoment.hours(),
          minute: slotMoment.minutes(),
          second: 0,
          millisecond: 0,
        });
        return nowInBiz.isSameOrAfter(slotToday) ? "Missed" : "upcoming";
      }
      return "upcoming";
    }

    return medType;
  };

  const [opened, { open, close }] = useDisclosure(false);
  const [isViewOpen, setIsViewOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [prnShow, setPRNShow] = useState(false);
  const [isNew, setIsNew] = useState(true);

  const prnRef = useRef();

  const compareDate = (date, medicationType, upcoming) => {
    var time1 = moment(date).startOf("day");
    var today = moment().startOf("day");
    if (
      calendar !== "weekly" &&
      calendar !== "monthly" &&
      medicationType === upcoming
    ) {
      return -1;
    } else if (time1.isSame(today)) {
      return 0;
    } else if (time1.isAfter(today)) {
      return 1;
    } else {
      return -1;
    }
  };

  const openPRNView = (data) => {
    setIsNew(false);
    prnRef?.current?.openView(data, data?.date);
    setPRNShow(true);
  };
  const prnClose = () => {
    setSelectedRow(null);
    setPRNShow(false);
  };

  const isToday = moment(date).isSame(moment(), "day");

  return (
    <>
      <div
        className={`${classes.monthCardBox} ${isToday ? classes.todayCard : ""} monthcard`}
      >
        <div className={classes.dateRow}>
          <Box
            className={`${classes.todayDte} ${isToday ? classes.todayDteActive : ""}`}
          >
            <p>{moment(date).format("D")}</p>
          </Box>
          <Box>
            {moment(date).format("D") == 1 && (
              <div>
                <p>{moment(date).format("MMM")}</p>
              </div>
            )}
          </Box>
        </div>
        {data
          ?.sort((a, b) => {
            // Always sort by timeSlot — for PRN entries the medicationType[].date
            // is normalized to noon UTC in adaptEntryToCard, so parsing it gives
            // the wrong sort order.  timeSlot is set to the actual administration
            // time string ("hh:mm A") for both PRN and Schedule entries.
            const timeA = moment(a?.timeSlot, "hh:mm A").format("HH:mm");
            const timeB = moment(b?.timeSlot, "hh:mm A").format("HH:mm");

            return timeA.localeCompare(timeB);
          })
          ?.slice(0, 5)
          ?.map((med, ind) => {
            // ── FIX: use robust helper instead of inline find ──────────────────
            // The old inline find used (!m.timeSlot || m.timeSlot === med.timeSlot)
            // which fails when the stored entry has a timeSlot that doesn't exactly
            // match, causing Refused/Out of Medication/Unable to Take to fall back
            // to "upcoming" — making isViewOpen=false and hiding staff details.
            const _medicationType = getMedicationStatusForDate(med, date);
            // ──────────────────────────────────────────────────────────────────

            const _upcoming = "upcoming";
            return (
              <>
                <div
                  style={{
                    backgroundColor: getColor(_medicationType)?.light,
                    borderColor: getColor(_medicationType)?.border,
                  }}
                  key={ind}
                  className={classes.monthCard}
                  onClick={() => {
                    setSelectedRow(med);
                    if (_medicationType === "PRN") {
                      return openPRNView(med);
                    }

                    // ── FIX: correctly set isViewOpen for ALL non-upcoming/non-missed
                    // statuses, including Refused, Out of Medication, Unable to Take.
                    // Previously these could resolve to "upcoming" due to the broken
                    // timeSlot match, keeping isViewOpen=false and hiding staff details.
                    _medicationType === _upcoming ||
                    _medicationType === "Missed"
                      ? setIsViewOpen(false)
                      : setIsViewOpen(true);
                    open();
                  }}
                >
                  {/* {_medicationType !== "Missed" &&
                    _medicationType !== "PRN" && (
                      <div
                        className="colorBox"
                        style={{
                          backgroundColor: getColor(_medicationType)?.dark,
                        }}
                      />
                    )} */}
                  <p
                    className="medName"
                    style={{
                      color: getColor(_medicationType)?.dark,
                    }}
                  >
                    {med?.form3?.medicationName}
                  </p>
                  {/* <p className="medDose">
                    {med?.form3?.dosage} {med?.form3?.unit}
                  </p> */}
                  <p
                    className="medTime"
                    style={{
                      color: getColor(_medicationType)?.dark,
                    }}
                  >
                    {_medicationType === "PRN" && med?.createdAt
                      ? moment.tz(moment(med.createdAt), profile?.user?.timeZone).format("hh:mm A")
                      : moment(med?.timeSlot, "hh:mm A")?.format("hh:mm A")}
                  </p>
                  {/* <div className="iconBox">
                    {_medicationType === "Taken" && (
                      <img
                        src={"/assets/images/done-icon.png"}
                        style={{ width: "12px", height: "12px" }}
                        alt="done-icon"
                      />
                    )}
                    {_medicationType === "Missed" && (
                      <img
                        src={"/assets/images/warning.png"}
                        style={{ width: "12px", height: "12px" }}
                        alt="warning-icon"
                      />
                    )}
                    {_medicationType === "Unable to Take" && (
                      <img
                        src={"/assets/images/do-not-disturb.png"}
                        style={{ width: "12px", height: "12px" }}
                        alt="unavailable-icon"
                      />
                    )}
                    {_medicationType === "Refused" && (
                      <img
                        src={"/assets/images/unavailable.png"}
                        style={{ width: "12px", height: "12px" }}
                        alt="unavailable-icon"
                      />
                    )}
                    {_medicationType === "Out of Medication" && (
                      <img
                        src={"/assets/images/close-white.png"}
                        style={{ width: "13px", height: "13px" }}
                        alt="close-icon"
                      />
                    )}
                  </div> */}
                </div>
              </>
            );
          })}
        {data?.length > 5 && (
          <MarDetailModal
            data={data}
            calendar={calendar}
            date={moment(date).format("MMMM DD, YYYY")}
          />
        )}
      </div>
      <PRNMedicationModal
        ref={prnRef}
        isNew={isNew}
        opened={prnShow}
        onclose={prnClose}
        data={selectedClient}
        date={date}
      />
      {selectedRow && (
        <MedicationModal
          onclose={() => {
            close();
            setIsViewOpen(false);
            setSelectedRow(null);
          }}
          date={date}
          opened={opened}
          data={selectedRow}
          allData={data}
          isViewOpen={isViewOpen}
          setIsViewOpen={setIsViewOpen}
          futureDate={compareDate(selectedRow?.date)}
        />
      )}
    </>
  );
};

export default React.memo(MonthCard);
